// Supermove
import {gql} from '@supermove/graphql';
import {Json, withFragment} from '@supermove/utils';

const copy = withFragment(
  (customer) => ({
    userId: (customer as any).id,
    organizationId: (customer as any).organizationId,
    names: (customer as any).names,
    aliasName: (customer as any).aliasName,
    firstName: (customer as any).firstName,
    lastName: (customer as any).lastName,
    phoneNumber: (customer as any).phoneNumber,
    email: (customer as any).email,
  }),
  gql`
    fragment CustomerForm_copy on User {
      id
      organizationId
      names
      aliasName
      firstName
      lastName
      phoneNumber
      email
    }
  `,
);

const edit = withFragment(
  (customer) => ({
    userId: (customer as any).id,
    organizationId: (customer as any).organizationId,
    names: (customer as any).names,
    aliasName: (customer as any).aliasName,
    firstName: (customer as any).firstName,
    lastName: (customer as any).lastName,
    phoneNumber: (customer as any).phoneNumber,
    email: (customer as any).email,
  }),
  gql`
    fragment CustomerForm_edit on User {
      id
      organizationId
      names
      aliasName
      firstName
      lastName
      phoneNumber
      email
    }
  `,
);

const _new = ({organizationId}: any) => ({
  userId: undefined,
  organizationId,
  names: '["", ""]',
  aliasName: '',
  firstName: '',
  lastName: '',
  phoneNumber: '',
  email: '',
});

const toForm = ({
  userId,
  organizationId,
  names,
  aliasName,
  firstName,
  lastName,
  phoneNumber,
  email,
}: any) => ({
  userId,
  organizationId,
  names: Json.toForm(names),
  aliasName,
  firstName,
  lastName,
  phoneNumber,
  email,
});

const toMutation = ({
  userId,
  organizationId,
  names,
  aliasName,
  firstName,
  lastName,
  phoneNumber,
  email,
}: any) => ({
  userId,
  organizationId,
  names: Json.toMutation(names.filter(Boolean).map((name: any) => name.trim())),
  aliasName,
  firstName,
  lastName,
  phoneNumber,
  email,
});

const CustomerForm = {
  copy,
  edit,
  new: _new,

  toForm,
  toMutation,
};

export default CustomerForm;
